import { render } from "./homeNews.vue?vue&type=template&id=3359d7b8&scoped=true"
import script from "./homeNews.vue?vue&type=script&lang=js"
export * from "./homeNews.vue?vue&type=script&lang=js"

import "./homeNews.vue?vue&type=style&index=0&id=3359d7b8&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3359d7b8"]])

export default __exports__